module.exports = __webpack_public_path__ + "img/logo-small.a97fa9fa.png";